<template>
  <div class="home">
    <el-tabs
      v-model="toggleName"
      class="tabs-self-defined"
      @tab-click="handleClick"
    >
      <el-tab-pane
        v-if="toggleService"
        key="second"
        label="维修首页"
        name="second"
      >
        <el-row :gutter="10">
          <el-col
            :xs="24"
            :sm="24"
            style="margin-top: 20px"
          >
            前6个月维修订单/任务数据统计
            <el-divider />
            <div
              id="line-echarts"
              class="tpl-echarts"
            />
          </el-col>
        </el-row>
      </el-tab-pane>
      <el-tab-pane
        v-if="toggleMap"
        key="third"
        label="地图首页"
        name="third"
      >
        <!-- 数据请求后 调这个方法getMapMarker -->
        <div class="homemap clearfix">
          <div
            :class="['options', showEngineer ? 'active' : '']"
            data-val="1"
            @click="engClick"
          >
            工程师位置
          </div>
          <div
            :class="['options', showCustomerOver ? 'active' : '']"
            data-val="1"
            @click="noCusClick"
          >
            没有未处理和进行中的客户
          </div>
          <div
            :class="['options', showCustomerIng ? 'active' : '']"
            data-val="1"
            @click="underwayClick"
          >
            有进行中订单的客户
          </div>
          <div
            :class="['options', showCustomerUn ? 'active' : '']"
            data-val="1"
            @click="untreatedClick"
          >
            有未处理订单的客户
          </div>
        </div>

        <div
          id="container"
          tabindex="0"
          style="min-height: 600px; height: 100%"
        />
        <div
          id="pickerBox"
          class="mapPickerbox"
        >
          <div id="pickerInput">
            (工程师位置5分钟取一次)
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane
        v-if="toggleEnginner"
        key="fourth"
        label="我的数据"
        name="fourth"
      >
        <el-row :gutter="10">
          <el-col
            :xs="24"
            :sm="8"
          >
            <div class="dashboard-stat taskcount">
              <div class="visual">
                <i class="el-icon-lollipop" />
              </div>
              <div class="details">
                <div class="number">
                  {{ engineerStatistics.taskCount }}
                </div>
                <div class="desc">
                  服务次数（总任务数）
                </div>
              </div>
            </div>
          </el-col>
          <el-col
            :xs="24"
            :sm="8"
          >
            <div class="dashboard-stat evaluatecount">
              <div class="visual">
                <i class="el-icon-edit-outline" />
              </div>
              <div class="details">
                <div class="number">
                  {{ engineerStatistics.evaluateCount }}
                </div>
                <div class="desc">
                  被评分次数（总被评分次数）
                </div>
              </div>
            </div>
          </el-col>
          <el-col
            :xs="24"
            :sm="8"
          >
            <div class="dashboard-stat averagescore">
              <div class="visual">
                <i class="el-icon-menu" />
              </div>
              <div class="details">
                <div class="number">
                  {{ engineerStatistics.averageScore }}
                </div>
                <div class="desc">
                  平均分（客户评价平均分）
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script src="https://webapi.amap.com/ui/1.0/main.js?v=1.0.11"></script>
<script>
import {
  exportDevice,
  exportEngineer,
  exportCustomer,
  dashboardDeviceUrl,
  dashboardEngineerUrl,
  dashboardCustomerUrl,
  dashboardOrderServiceUrl,
  dashboardOrderUrl,
  getMajorMonth,
  getEngineerStatistics,
  getMapData,
} from "@/api/home";
import { UserModule } from "../../store/modules/user";
import map_customer_0 from "@/assets/images/map_customer_0.png";
import map_customer_1 from "@/assets/images/map_customer_1.png";
import map_customer_2 from "@/assets/images/map_customer_2.png";
import map_gcs from "@/assets/images/map_gcs.png";

import {
  checkPermissionCompany,
  checkPermissionRole,
} from "@/utils/permission";
import { Type, ModuleType } from "../../types/permissionType";
var echarts = require("echarts");

export default {
  name: "Home",
  components: {},
  data() {
    return {
      //首页 first second third fourth five six
      toggleName: "second",
      toggleService: true,
      toggleMap: true,
      toggleEnginner: true,
      //维修首页 折线图
      majorMonth: {
        allOrderCount: [],
        unfinishOrderCount: [],
        finishOrderCount: [],
        allTaskCount: [],
        unfinshTaskCount: [],
        finshTaskCount: [],
        abnormalTaskCount: [],
        monthName: [],
      },
      //工程师首页 统计
      engineerStatistics: {
        taskCount: 0,
        evaluateCount: 0,
        averageScore: 0,
      },

      mapData: {},
      map: null,
      marker: null,
      showEngineer: true,
      showCustomerOver: true,
      showCustomerIng: true,
      showCustomerUn: true,

      mapOnce: true,
      engineerOnce: true,

      untreatedMarkerList: [],
      underwayMarkerList: [],
      engMarkerList: [],
      noMarkerList: [],
    };
  },

  computed: {
    classOption: function () {
      return {
        step: 0.5,
        limitMoveNum: 10,
      };
    },
    classOptionTable: function () {
      return {
        step: 0.5,
        limitMoveNum: 5,
      };
    },
  },

  mounted() {
    // 初始化
    this.echartsDataLine();

    this.map = new AMap.Map("container", {
      zoom: 16,
      resizeEnable: true,
    });

    // this.map.clearMap(); // 清除地图覆盖物
  },

  created() {
    this.$nextTick(function () {
      this.toggleService = checkPermissionRole(
        UserModule.getCompanyId,
        Type.ORDER_LOOK_COM
      );
    });

    this.$nextTick(function () {
      this.toggleMap = checkPermissionRole(
        UserModule.getCompanyId,
        Type.HOME_MAP
      );
    });

    this.$nextTick(function () {
      this.toggleEnginner =
        checkPermissionRole(UserModule.getCompanyId, Type.TASK_LOOK) ||
        checkPermissionRole(UserModule.getCompanyId, Type.TASK_DEAL);
    });
    // checkPermissionCompany 变为 checkPermissionRole ljd

    this.$nextTick(function () {
       if (this.toggleService) {
        this.toggleName = "second";
        this.getMajorMonth();
      } else if (this.toggleMap) {
        this.toggleName = "third";
        this.getMapData();
      } else if (this.toggleEnginner) {
        this.toggleName = "fourth";
        this.getEngineerStatistics();
      }
    });
  },
  methods: {
    showErrorMsg(msg) {
      this.$notify({
        title: "提示",
        message: msg,
        offset: 100,
        type: "error",
      });
    },
    showSecussMsg(msg) {
      this.$notify({
        title: "提示",
        message: msg,
        offset: 100,
        type: "success",
      });
    },
    handleClick(tab, event) {
      if (this.toggleName === "second") {
        this.getMajorMonth();
      }
      if (this.toggleName === "third") {
        this.getMapData();
      }
      if (this.toggleName == "fourth") {
        this.getEngineerStatistics();
      }
    },
    //维修首页 折线图数据获取
    getMajorMonth() {
      let p = {};
      p.user_id = UserModule.getUserId;
      p.company_id = UserModule.getCompanyId;
      getMajorMonth(p)
        .then((res) => {
          const data = res.data;
          if (data !== null) {
            this.majorMonth = data;
            this.echartsDataLine();
          }
        })
        .catch((err) => {
          let msg = err.msg;
        });
    },
    //工程师首页 数据获取
    getEngineerStatistics() {
      let p = {};
      p.user_id = UserModule.getUserId;
      p.company_id = UserModule.getCompanyId;
      if (this.engineerOnce) {
        getEngineerStatistics(p)
          .then((res) => {
            const data = res.data;
            if (data !== null) {
              this.engineerOnce = false;
              this.engineerStatistics = data;
            }
          })
          .catch((err) => {
            let msg = err.msg;
          });
      }
    },
    //地图首页 数据获取
    getMapData() {
      let p = {};
      p.user_id = UserModule.getUserId;
      p.company_id = UserModule.getCompanyId;
      if (this.mapOnce) {
        getMapData(p)
          .then((res) => {
            const data = res.data;
            if (data !== null) {
              this.mapOnce = false;
              this.untreatedMarkerList = [];
              this.underwayMarkerList = [];
              this.mapData = data;
              this.map.clearMap(); // 清除地图覆盖物
              // this.getMapMarker(this.mapData);
              this.addCustomer(this.mapData.customer);
              this.addEngineer(this.mapData.engineer);
            }
          })
          .catch((err) => {
            let msg = err.msg;
          });
      }
    },

    //维修首页 折线图 初始化
    echartsDataLine() {
      let myChartsta = echarts.init(document.getElementById("line-echarts"));

      let option = {
        tooltip: {
          trigger: "axis",
        },
        legend: {
          // orient: 'vertical',
          // x: 'right',
          data: [
            "订单总数",
            "未完成订单",
            "已完成订单",
            "任务总数",
            "未完成任务",
            "已完成任务",
            "异常结束任务",
          ],
        },
        toolbox: {
          show: true,
          top: "bottom",
          feature: {
            dataView: {
              readOnly: false,
              show: true,
              title: "",
              lang: ["数据视图", "关闭", "刷新"],
            },
            magicType: {
              title: "",
              type: ["line", "bar"],
            },
            restore: {},
            saveAsImage: {
              title: "",
            },
          },
          iconStyle: {
            borderColor: "#555",
          },
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.majorMonth.monthName,
        },
        yAxis: {
          type: "value",
        },
        series: [
          {
            name: "订单总数",
            type: "line",
            lineStyle: {
              color: "#b88bf8",
              width: 1,
              type: "solid",
            },
            data: this.majorMonth.allOrderCount,
          },
          {
            name: "未完成订单",
            type: "line",
            lineStyle: {
              color: "#69a3fb",
              width: 1,
              type: "solid",
            },
            data: this.majorMonth.unfinishOrderCount,
          },
          {
            name: "已完成订单",
            type: "line",
            lineStyle: {
              color: "#2ac99c",
              width: 1,
              type: "solid",
            },
            data: this.majorMonth.finishOrderCount,
          },
          {
            name: "任务总数",
            type: "line",
            lineStyle: {
              color: "#b88bf8",
              width: 1,
              type: "dashed",
            },
            data: this.majorMonth.allTaskCount,
          },
          {
            name: "未完成任务",
            type: "line",
            lineStyle: {
              color: "#69a3fb",
              width: 1,
              type: "dashed",
            },
            data: this.majorMonth.unfinshTaskCount,
          },
          {
            name: "已完成任务",
            type: "line",
            lineStyle: {
              color: "#2ac99c",
              width: 1,
              type: "dashed",
            },
            data: this.majorMonth.finshTaskCount,
          },
          {
            name: "异常结束任务",
            type: "line",
            lineStyle: {
              color: "#fc7b6a",
              width: 1,
              type: "dashed",
            },
            data: this.majorMonth.abnormalTaskCount,
          },
        ],
        color: [
          "#b88bf8",
          "#69a3fb",
          "#2ac99c",
          "#b88bf8",
          "#69a3fb",
          "#2ac99c",
          "#fc7b6a",
        ],
      };

      myChartsta.setOption(option);
    },
    // 地图点击显示

    engClick() {
      this.showEngineer = !this.showEngineer;
      if (this.showEngineer) {
        this.map.add(this.engMarkerList);
      } else {
        this.map.remove(this.engMarkerList);
      }

      // setTimeout(() => {
      //   this.map.add(this.engMarkerList);
      // }, 1000 * 10);
    },
    noCusClick() {
      this.showCustomerOver = !this.showCustomerOver;
      if (this.showCustomerOver) {
        this.map.add(this.noMarkerList);
      } else {
        this.map.remove(this.noMarkerList);
      }
    },
    underwayClick() {
      this.showCustomerIng = !this.showCustomerIng;
      if (this.showCustomerIng) {
        this.map.add(this.underwayMarkerList);
      } else {
        this.map.remove(this.underwayMarkerList);
      }
    },
    untreatedClick() {
      this.showCustomerUn = !this.showCustomerUn;
      if (this.showCustomerUn) {
        this.map.add(this.untreatedMarkerList);
      } else {
        this.map.remove(this.untreatedMarkerList);
      }
    },

    //地图首页 客户标点
    addCustomer(r) {
      var markers = r || [];
      var _this = this;
      var number = "";
      // 添加一些分布不均的点到地图上,地图上添加三个点标记，作为参照
      for (let i = 0; i < markers.length; i++) {
        let marker = markers[i];
        var img = map_customer_0;
        if (marker.order_underway <= 0 && marker.order_untreated <= 0) {
          number = "";
          let markera = new AMap.Marker({
            // map: _this.map,
            icon: img,
            position: [marker.longitude, marker.latitude],
            offset: new AMap.Pixel(-13, -30),
          });

          markera.setLabel({
            offset: new AMap.Pixel(18, -15), //设置文本标注偏移量
            content: number, //设置文本标注内容
          });

          AMap.event.addListener(markera, "click", function () {
            _this.openInfo(
              marker.longitude,
              marker.latitude,
              marker.name + "(" + marker.mobile + ") <br>" + marker.area
            );
          });
          this.noMarkerList.push(markera);
        }
        if (marker.order_underway > 0) {
          img = map_customer_2;
          number = marker.order_underway;
          let markera = new AMap.Marker({
            // map: _this.map,
            icon: img,
            position: [marker.longitude, marker.latitude],
            offset: new AMap.Pixel(-13, -30),
          });

          markera.setLabel({
            offset: new AMap.Pixel(18, -15), //设置文本标注偏移量
            content: number, //设置文本标注内容
          });

          AMap.event.addListener(markera, "click", function () {
            _this.openInfo(
              marker.longitude,
              marker.latitude,
              marker.name + "(" + marker.mobile + ") <br>" + marker.area
            );
          });
          this.underwayMarkerList.push(markera);
        }
        if (marker.order_untreated > 0) {
          img = map_customer_1;
          number = marker.order_untreated;
          let markera = new AMap.Marker({
            // map: _this.map,
            icon: img,
            position: [marker.longitude, marker.latitude],
            offset: new AMap.Pixel(-13, -30),
          });

          markera.setLabel({
            offset: new AMap.Pixel(18, -15), //设置文本标注偏移量
            content: number, //设置文本标注内容
          });

          AMap.event.addListener(markera, "click", function () {
            _this.openInfo(
              marker.longitude,
              marker.latitude,
              marker.name + "(" + marker.mobile + ") <br>" + marker.area
            );
          });
          this.untreatedMarkerList.push(markera);
        }
      }
      this.map.add(this.noMarkerList);
      this.map.add(this.underwayMarkerList);
      this.map.add(this.untreatedMarkerList);
      this.map.setFitView();
    },
    //地图首页 工程师标点
    addEngineer(r) {
      let markers = r || [];
      let _this = this;
      let geocoder = new AMap.Geocoder();

      // 添加一些分布不均的点到地图上,地图上添加三个点标记，作为参照
      for (let i = 0; i < markers.length; i++) {
        let marker = markers[i];
        let markera = new AMap.Marker({
          // map: _this.map,
          icon: map_gcs,
          position: [marker.longitude, marker.latitude],
          offset: new AMap.Pixel(-13, -30),
        });
        markera.setLabel({
          offset: new AMap.Pixel(18, -15), //设置文本标注偏移量
          content: marker.num, //设置文本标注内容
        });
        geocoder.getAddress(
          new AMap.LngLat(marker.longitude, marker.latitude),
          function (status, result) {
            let area = "";
            if (status === "complete" && result.regeocode) {
              area = result.regeocode.formattedAddress;
              AMap.event.addListener(markera, "click", function () {
                _this.openInfo(
                  marker.longitude,
                  marker.latitude,
                  marker.name + "(" + marker.mobile + ") <br/>" + area
                );
              });
            } else {
              AMap.event.addListener(markera, "click", function () {
                _this.openInfo(
                  marker.longitude,
                  marker.latitude,
                  marker.name + "(" + marker.mobile + ") <br/>" + area
                );
              });
            }
          }
        );
        this.engMarkerList.push(markera);
      }
      this.map.add(this.engMarkerList);
      this.map.setFitView();
    },
    //地图首页 点击标点打开显示
    openInfo(lng, lat, centent) {
      var infoWindow = new AMap.InfoWindow({
        content: centent, //使用默认信息窗体框样式，显示信息内容
        offset: new AMap.Pixel(0, -25),
      });

      infoWindow.open(this.map, [lng, lat]);
    },
  },
};
</script>

<style lang="css">
.text-ellipsis {
  height: 2em;
  overflow: hidden;
}
.scroll_bg {
  width: 100%;
  height: 450px;
  overflow: hidden;
  position: relative;
  border: solid 1px #f5f5f5;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  padding: 0 10px;
  margin: 10px 0 20px;
}
.scroll_bg ul {
  list-style: none;
  padding: 0;
  margin: 0;
}
.scroll_bg li {
  width: 100%;
  padding: 14px 0;
  min-height: 45px;
  overflow: hidden;
  display: flex;
  justify-content: space-between;
  border-bottom: solid 1px #f5f5f5;
  white-space: nowrap;
  text-overflow: clip;
}

.scroll_bg li .title {
  max-width: 80%;
  overflow: hidden;
  text-overflow: ellipsis;
}

.countTime {
  letter-spacing: 1px;
  font-size: 12px;
  margin: 10px;
  color: #666;
}

.amap-marker-label {
  width: 25px;
  height: 25px;
  font-size: 3px;
  size: 3px;
  color: #ffffff;
  text-align: center;
  background-color: #f7534f;
  border-radius: 50%;
  border-color: #f7534f;
}
</style>
